/* eslint-disable react/self-closing-comp */
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, IconButton, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import logo from '../../../assets/images/logo.png';
import 'flag-icons/css/flag-icons.min.css';
import Nav from '../nav/Nav';
import './Navbar.css';

function Navbar() {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || i18n.language
  );
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (localStorage.getItem('language')) {
      i18n.changeLanguage(localStorage.getItem('language'));
    }
  }, []);

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    setAnchorEl(null);

    // ✅ SUPPRIMÉ: document.documentElement.dir = ...
    // Cette ligne mettait dir="rtl" sur tout le <html> et cassait
    // le layout Bootstrap (formulaire déplacé à gauche en arabe).
    // Le RTL est maintenant géré localement dans chaque composant
    // via dir={isRTL ? 'rtl' : 'ltr'} sur les éléments ciblés.
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const getFlagClassName = (language) => {
    switch (language) {
      case 'en': return 'fi fi-gb';
      case 'fr': return 'fi fi-fr';
      case 'de': return 'fi fi-de';
      case 'esp': return 'fi fi-es';
      case 'ar': return 'fi fi-sa';
      case 'port': return 'fi fi-pt';
      default: return '';
    }
  };

  const getLanguageName = (language) => {
    switch (language) {
      case 'en': return 'English';
      case 'fr': return 'Français';
      case 'de': return 'Deutsch';
      case 'esp': return 'Español';
      case 'ar': return 'العربية';
      case 'port': return 'Português';
      default: return '';
    }
  };

  return (
    <section>
      {/* ✅ La navbar est toujours en LTR — logo à gauche, langue à droite */}
      <nav className="navbar" style={{ direction: 'ltr' }}>
        <div
          className="container"
          style={{ display: 'flex', alignItems: 'center', minHeight: 64 }}
        >
          {/* Gauche : logo — toujours à gauche */}
          <NavLink className="navbar-brand" to="/">
            <img alt="logo" className="img-fluid" src={logo} width="150" />
          </NavLink>

          {/* Centre : liens de navigation */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Nav />
          </Box>

          {/* Droite : sélecteur de langue — toujours à droite */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
              color="inherit"
              onClick={handleClick}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <span
                className={getFlagClassName(selectedLanguage)}
                style={{ marginRight: 10 }}
              />
              <Typography variant="body1">
                {getLanguageName(selectedLanguage)}
              </Typography>
              <ExpandMoreIcon style={{ marginLeft: 5 }} />
            </IconButton>
          </Box>

          {/* Menu dropdown de langue */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={() => handleLanguageChange('en')}>
              <span className="fi fi-gb" style={{ marginRight: 10 }} /> English
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange('fr')}>
              <span className="fi fi-fr" style={{ marginRight: 10 }} /> Français
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange('de')}>
              <span className="fi fi-de" style={{ marginRight: 10 }} /> Deutsch
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange('esp')}>
              <span className="fi fi-es" style={{ marginRight: 10 }} /> Español
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange('ar')}>
              <span className="fi fi-sa" style={{ marginRight: 10 }} /> العربية
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange('port')}>
              <span className="fi fi-pt" style={{ marginRight: 10 }} /> Português
            </MenuItem>
          </Menu>
        </div>
      </nav>
    </section>
  );
}

export default Navbar;